module.exports = __webpack_public_path__ + "img/gut_logo.ef6777e1.png";